<template>
    <app-container class="travels-post-view">
        <blog-content :data="data"/>
    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import BlogContent from '@/views/Blog/components/BlogContent'
    import getArticleDetailService from '@service/getArticleDetailService'
    
    export default {
        name: "TravelsPostView",
        props: {
            id: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                data: null
            }
        },
        mounted() {
            this.getArticleDetail(this.id)
        },
        methods: {
            async getArticleDetail(id) {
                const data = await getArticleDetailService({id})
                this.data = data
            }
        },
        components: {
            AppContainer,
            BlogContent
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    
    .travels-post-view {
        padding: $paddingMD;
        max-width: 800px;
    }
</style>